function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 30,
  height: 30,
  rx: 15,
  fill: "#333"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.663 10.918a1 1 0 01.085 1.412l-7.68 8.666a1 1 0 01-1.418.08l-4.32-3.9a1 1 0 011.34-1.485l3.571 3.224 7.01-7.912a1 1 0 011.412-.085z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 30,
  height: 30,
  rx: 15,
  stroke: "#333",
  strokeWidth: 2
});

function SvgCircleCheckThick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiByeD0iMTUiIGZpbGw9IiMzMzMzMzMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMi42NjMyIDEwLjkxODFDMjMuMDc2NiAxMS4yODQ0IDIzLjExNDcgMTEuOTE2NCAyMi43NDg0IDEyLjMyOTdMMTUuMDY4NCAyMC45OTY0QzE0Ljg5MTUgMjEuMTk2MSAxNC42NDIxIDIxLjMxNjggMTQuMzc1NiAyMS4zMzE2QzE0LjEwOTIgMjEuMzQ2NSAxMy44NDggMjEuMjU0MiAxMy42NDk5IDIxLjA3NTRMOS4zMjk5IDE3LjE3NTVDOC45MTk5NiAxNi44MDU0IDguODg3NjUgMTYuMTczIDkuMjU3NzQgMTUuNzYzMUM5LjYyNzgzIDE1LjM1MzEgMTAuMjYwMiAxNS4zMjA4IDEwLjY3MDEgMTUuNjkwOUwxNC4yNDEgMTguOTE0NkwyMS4yNTE2IDExLjAwMzNDMjEuNjE3OSAxMC41OSAyMi4yNDk5IDEwLjU1MTggMjIuNjYzMiAxMC45MTgxWiIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiByeD0iMTUiIHN0cm9rZT0iIzMzMzMzMyIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";
export { SvgCircleCheckThick as ReactComponent };